import { ExploreContext } from "../useExploreContext";
import {
  serializeParams,
  unserializeParams,
} from "src/search/lib/params-state-reducer";
import { serializeContentView, unserializeContentView } from "./useContentView";
import { serializeDocument, unserializeDocument } from "./useExploreDocument";
import { serializeTabs, unserializeTabs } from "./useTabs";

export const serializableContext = (
  ctx: Pick<ExploreContext, "params" | "doc" | "view" | "tabs">
) => {
  return {
    s: serializeParams(ctx.params.state),
    d: serializeDocument(ctx.doc),
    v: serializeContentView(ctx.view),
    t: serializeTabs(ctx.tabs),
  };
};

export const serializedContext = (
  ctx: Pick<ExploreContext, "params" | "doc" | "view" | "tabs">
) => {
  return JSON.stringify(serializableContext(ctx));
};

export const unserializedContext = (encoded: string) => {
  try {
    const { s, d, v, t } = JSON.parse(encoded);
    const params = unserializeParams(s);
    const doc = unserializeDocument(d);
    const view = unserializeContentView(v);
    const tabs = unserializeTabs(t);
    return { params, doc, view, tabs };
  } catch {}
};
